"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const accountbrand02 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-accountbrand02` : '') + (description ? ` desc-accountbrand02` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-accountbrand02"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-accountbrand02"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.724 37.612C5.724 55.5 20.225 70 38.112 70S70.5 55.5 70.5 37.612C70.5 19.725 56 5.225 38.112 5.225c-17.887 0-32.388 14.5-32.388 32.387Z",
    fill: "#FFCCD8",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#E90B5A"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.773 26.91c0-8.9 7.215-16.114 16.115-16.114 8.9 0 16.114 7.215 16.114 16.114 0 8.9-7.215 16.115-16.114 16.115-8.9 0-16.115-7.215-16.115-16.115Zm16.115-14.114c-7.795 0-14.115 6.32-14.115 14.114 0 7.795 6.32 14.115 14.115 14.115s14.114-6.32 14.114-14.115-6.32-14.114-14.114-14.114ZM13.277 58.236a29.058 29.058 0 0 1 41.222 0 1 1 0 0 1-1.419 1.41 27.058 27.058 0 0 0-38.385 0 1 1 0 1 1-1.418-1.41Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M.5 33.388C.5 14.948 15.448 0 33.888 0c18.44 0 33.387 14.948 33.387 33.388 0 18.44-14.948 33.387-33.387 33.387C15.448 66.775.5 51.827.5 33.388ZM33.888 2C16.553 2 2.5 16.053 2.5 33.388s14.053 31.387 31.388 31.387 31.387-14.052 31.387-31.387S51.223 2 33.888 2Z"
  }))));
};
var _default = exports.default = accountbrand02;